// Tiny shared store so the AgeGate loader reflects real hero-frame preload progress.
let progress = 0; // 0..1
const subs = new Set();

export function setHeroProgress(p) {
  progress = Math.max(0, Math.min(1, p));
  subs.forEach((fn) => fn(progress));
}

export function getHeroProgress() {
  return progress;
}

export function subscribeHeroProgress(fn) {
  subs.add(fn);
  return () => subs.delete(fn);
}
